import * as React from 'react';
import { Edit, EditProps, NumberInput, SimpleForm, TextInput } from 'react-admin';
import { UploadImage } from '../components/UploadImage';

export const ProductCategoryEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} source="name" label="NAME"/>
				{/*<TextInput multiline step={1} source="description" label="DESCRIPTION"/>*/}
				<UploadImage step={1} source="imageUrl" label="IMAGE"/>
			</SimpleForm>
		</Edit>
	);
};
